module.exports = __webpack_public_path__ + "img/SH11X5.png";